import Mixin from "../mixin.js";
import FormInputs from "../services/inputs-service.js";
import Funnel from "../services/funnel-service.js";
const template = ` 
  <transition name="modal"  @enter="computeMarginTop()" appear>
    <div role="dialog"  aria-modal="true" :aria-labelledby="'modal_'+iuid+'_header'" class="modal-mask"  :ref="'modal_'+input.uid" :key="'modal_'+input.uid" v-if="!input.hidden" @keydown.esc="toggleModal()">
      <div class="modal-wrapper">
        <div class="s12 clm center" :class="input.class" :style="styleObject" :id="'modal_'+iuid">
          <div class="card modal-card">
            <button  aria-label="Close modal" class="button small circle close" @click.prevent="fs.toggleModal(input.uid)"/>
            <div class="modal-header" v-if="input.modal_header">
              <slot name="header">
                <h2 :id="'modal_'+iuid+'_header'" class="text-center" v-html="input.modal_header"/>
              </slot>
            </div>
            <div class="divider solid" v-if="input.modal_header"/>
            <div class="modal-body grid">
              <div v-if="input.modal_body" class="s12 clm" v-html="input.modal_body"/>
              <div v-if="input.modal_footer" class="s12 clm" v-html="input.modal_footer"/>
            </div>
            <div class="modal-footer grid">
              <button 
              :class="'s12 clm button medium secondary-action fill secondary-btn next-step '+ input.modal_button.button_class" 
              v-if="input.modal_button && input.modal_button.button_text"
              @click.prevent="exec($event, input)" >
                {{input.modal_button.button_text}}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
`;
export default {
    name: 'b-modal',
    template,
    props: ['iuid'],
    mixins: [Mixin],
    data: function(){
      return{
        styleObject:{}
      }
    },
    // watch:{
    //   'input.hidden':{
    //     handler: function(newVal){
    //       var self = this
    //       if (newVal == false) {

    //       }
    //     }
    //   }
    // },
    computed: {
      input: function () {
          return this.$store.getters.funnel.elements[this.iuid];
      },
      loadingText: function(){
          return this.$store.state.loading.text
      },
      fs: function () {
          return new Funnel({ ctx: this.$store, router: this.$router });
      }
        
    },
    methods: {
        /* exec: function (e, fxn) {
            const fi = new FormInputs({ ctx: this.$store, router: this.$router });
            const input = this.input;
            eval(`fi.${fxn}(e, input)`);
        }, */
        toggleModal: function(){
          console.log('toggleModal');
          this.$store.commit('UPDATE_FUNNEL_ELEM', { iuid: this.input.uid, key: 'hidden', val: !this.input.hidden});
        },
        computeMarginTop: function(){
            this.styleObject = {}
            var modal = document.getElementById('modal_'+this.iuid);
            var body = document.body;
            // var w = modal.offsetWidth;
            var h = modal.offsetHeight;
            var wh = window.innerHeight;
            // var bw = body.clientWidth;
            if (h >= wh) {
              return
            }
            this.styleObject.marginTop = (wh/2 - h/2) + "px"
            this.$forceUpdate()
        }
    }
};
// "sample_modal":{
//     "uid":"sample_modal",
//     "header":"sample header text"
//     "body":"sample body text"
//     "footer":"sample footer text",
//     "button_text":"Btn TXT",
//     "fxn": {
//         "click": "closeModal"
//     },
//     "display": {
//         "in_insurance_type": {
//             "eq": "auto"
//         }
//     }
// }